export var Locale;
(function (Locale) {
    Locale["en"] = "en";
    Locale["ar"] = "ar";
    Locale["fr"] = "fr";
    Locale["es"] = "es";
    Locale["de"] = "de";
})(Locale || (Locale = {}));
//# sourceMappingURL=i18n-controller.js.map